import { EstateCard } from "@/components/hlidaci-pes/EstateCard";
import { Button } from "@/components/ui/Button";
import { useLanguage } from "@/context/LanguageContext";
import { useWatchDogContext } from "@/context/WatchDogContext";

const WatchDogSpecificResults = () => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      showMore: "Ukázat více",
      showLess: "Ukázat méně",
    },
    en: {
      showMore: "Show more",
      showLess: "Show less",
    },
  }[language];
  const {
    sortedEstateOffers,
    editSpecificResult,
    visibleCount,
    handleShowMore,
    handleShowLess,
  } = useWatchDogContext();
  const visibleOffers = sortedEstateOffers.slice(0, visibleCount);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        {visibleOffers.map((offer) => (
          <div key={offer.id}>
            <EstateCard
              estateOffer={offer}
              isMainPage={false}
              editSpecificResult={editSpecificResult}
            />
          </div>
        ))}
      </div>

      {(visibleCount < sortedEstateOffers.length || visibleCount > 20) && (
        <div className="flex justify-center mt-6 gap-3">
          {visibleCount < sortedEstateOffers.length && (
            <Button variant="outline" size="sm" onClick={handleShowMore}>
              {copy.showMore}
            </Button>
          )}
          {visibleCount > 20 && (
            <Button variant="outline" size="sm" onClick={handleShowLess}>
              {copy.showLess}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default WatchDogSpecificResults;
